import React, {useEffect, useRef} from "react";

import Header from "../header";
import HomeBanner from "../homeBanner";
import BookingForms from "../bookingForms";
import CarCarousel from "../carCarousel";
import Footer from "../footer";
import SEO from "../seo";
import MapAndAddress from "../mapAndAddress";
import { _osTrackingEvent } from "./_osTrackingEvent";

import "../../css/layout.css";

const Layout = (props) => {
  const {
    pageContext: {
      Address,
      City,
      ClientID,
      ConversionPixelID,
      Dealer_Name,
      FB_Page_link,
      GMB_Link,
      Latitude,
      Longitude,
      PixelID,
      Zone,
      Region,
      State,
      Virtual_Numbers,
      carName,
      carIndex,
      carDisplayName,
      isExperimental,
    },
  } = props;
  const setFieldsFlag = useRef(true);

  const handleSetData = () => {
    if (typeof window !== "undefined" && typeof window._osSetIds === "function" && setFieldsFlag.current) {
      window._osSetIds({
        client_id: ClientID,
        googlePixelId: PixelID,
        googleConversionId: ConversionPixelID,
      });

      setFieldsFlag.current = false;

      _osTrackingEvent({
        leadStep: "viewproduct",
        product_names: carDisplayName || "grand_i10_nios"
      })
    }
  };

  useEffect(() => {
    if(setFieldsFlag.current) {
      handleSetData();
    }
  });

  const _osOnPageClick = (event) => {
    try{
      let eventTarget = event?.target;
      let targetClassName = [];
      if(typeof(eventTarget.className) == "string"){
        targetClassName.push(eventTarget.className);
        targetClassName.join("")
      }else{
        for(let i = 0; i< eventTarget.classList.length; i++){
          targetClassName.push(eventTarget.classList[i])
        }
        targetClassName.join(",")
      }
      if(eventTarget){
        let paramObj ={
          leadStep:"onDOMClick",
          product_names: carDisplayName,
          clickDOM:event.target.id || targetClassName || event.target.tagName
        }
        _osTrackingEvent(paramObj)
      }
    }catch(error){

    }
  }

  const renderBookingForms = (props) => {
    return (
      <BookingForms
        carDisplayName={carDisplayName}
        ClientId={ClientID}
        PixelID={PixelID}
        formGridSize={12}
        formBookingId="footerBookDriveForm"
        {...props}
      />
    )
  }

  return (
    <>
      <div
        style={{
          margin: `0 auto`,
          paddingTop: 0,
        }}
        onClick={_osOnPageClick}
      >
        <SEO {...props} />
        <main>
          <Header dealer={Dealer_Name} contact={Virtual_Numbers} />
          <HomeBanner carName={carName} />
          <CarCarousel carIndex={carIndex} />
          <BookingForms
            carDisplayName={carDisplayName}
            ClientId={ClientID}
            PixelID={PixelID}
          />
          <MapAndAddress
            address={Address}
            dealer={Dealer_Name}
            gmbLink={GMB_Link}
            lat={Latitude}
            lng={Longitude}
          />
          <Footer
            isExperimental={isExperimental}
            address={Address}
            lat={Latitude}
            lng={Longitude}
            contact={Virtual_Numbers}
            gmbLink={GMB_Link}
            fbLink={FB_Page_link}
            carDisplayName={carDisplayName}
            bookingFormDom={renderBookingForms}
          />
          <input type="hidden" id="zone-hidden" value={Zone} />
          <input type="hidden" id="region-hidden" value={Region} />
          <input type="hidden" id="city-hidden" value={City} />
          <input type="hidden" id="state-hidden" value={State} />
        </main>
      </div>
    </>
  );
};

export default Layout;
